import React from "react";
import { useDispatch } from "react-redux";
import CatalogList from "@components/Features/catalog/catalog-list/catalog-list";
import { MAIN_PAGE_ADBLOCK_POSITIONS, TimeSort } from "@components/Features/catalog/catalog-utils";
import { setMainScreenParamsSort, setMainScreenTimeSort } from "@app/store/filtersSlice";
import { MainScreenCatalogProps } from "./MainScreenCatalog.props";
import classes from "./MainScreen.module.scss";

const MainScreenCatalog: React.FC<MainScreenCatalogProps> = ({
    error,
    isLoading,
    data,
    mainScreenAllParamsSort,
    mainScreenTimeSort,
    isFetching,
    dataMemory,
    showMoreButton,
    page,
    setPage,
    setDataMemory
}) => {
    const dispatch = useDispatch();

    return (
        <div className={classes["main-screen__catalog"]}>
            {error && (
                <div className={classes["main-screen__catalog-error"]}>Ошибка загрузки данных</div>
            )}
            {isLoading && <div className="custom-loader"></div>}

            {data?.offers && (
                <CatalogList
                    title="Последние объявления"
                    headerTag="h2"
                    defaultTimeSort={TimeSort.Week}
                    onTimeSortChanged={(sort) => {
                        dispatch(setMainScreenTimeSort(sort));
                    }}
                    onParamsSortChanged={(sort) => {
                        dispatch(setMainScreenParamsSort(sort));
                    }}
                    allParamsSort={mainScreenAllParamsSort}
                    timeSort={mainScreenTimeSort}
                    isDataLoading={isFetching}
                    data={dataMemory}
                    showLoadMore={showMoreButton}
                    loadMore={async () => {
                        setPage(page + 1);
                    }}
                    onFilterChanged={() => {
                        setPage(1);
                        setDataMemory([]);
                    }}
                    showResetFiltersWhenNoData={false}
                    page={page}
                    adBlockPositions={MAIN_PAGE_ADBLOCK_POSITIONS}
                />
            )}
        </div>
    );
};

export default MainScreenCatalog;